import { render, staticRenderFns } from "./CreatePerson.vue?vue&type=template&id=6bce69a7"
import script from "./CreatePerson.vue?vue&type=script&lang=js"
export * from "./CreatePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports